import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
import Cookies from "universal-cookie";
import Header from "components/Headers/Header";
import axios from "axios";
import Swal from "sweetalert2";

const Perfil = () => {
  const cookies = new Cookies();
  const idUsuario = cookies.get("id");

  const [form, setForm] = useState({
    id: "",
    usuario: "",
    nombre: "",
    direccion: "",
    municipio: "",
    telefono: "",
    correo: "",
    tipoUsuarioId: "",
    estado: "",
    regionalId: "",
    contrasena: "",
    tallerId: "",
    documento: "",
    equipoAsignado: "",
  });

  useEffect(() => {
    if (idUsuario) {
      axios
        .get(
          `https://inspecciongnvback.azurewebsites.net/api/v1/ObtenerUsuarioPorId/${idUsuario}`,
        )
        .then((res) => {
          const data = res.data;
          setForm({
            ...data,
            contrasena: "", // nunca mostrar contraseña real
          });
        })
        .catch((error) => {
          console.error("Error cargando perfil:", error);
        });
    }
  }, [idUsuario]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdate = async () => {
    try {
      const payload = { ...form };
      if (!payload.contrasena) delete payload.contrasena;

      await axios.put(
        `https://inspecciongnvback.azurewebsites.net/api/v1/ActualizaUsuarios/${form.id}`,
        payload,
      );

      Swal.fire(
        "Actualizado",
        "Los datos se guardaron correctamente",
        "success",
      );
    } catch (error) {
      console.error("Error actualizando:", error);
      Swal.fire("Error", "No se pudo actualizar el perfil", "error");
    }
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <Col xl="12">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0">Editar Perfil</h3>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Form>
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <label>Nombre</label>
                        <Input
                          name="nombre"
                          value={form.nombre}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <label>Usuario</label>
                        <Input
                          name="usuario"
                          value={form.usuario}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <label>Correo</label>
                        <Input
                          name="correo"
                          value={form.correo}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <label>Teléfono</label>
                        <Input
                          name="telefono"
                          value={form.telefono}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <label>Dirección</label>
                        <Input
                          name="direccion"
                          value={form.direccion}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <label>Municipio</label>
                        <Input
                          name="municipio"
                          value={form.municipio}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <label>Documento</label>
                        <Input
                          name="documento"
                          value={form.documento}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <label>Nueva Contraseña</label>
                        <Input
                          type="password"
                          name="contrasena"
                          value={form.contrasena}
                          onChange={handleChange}
                          placeholder="Nueva contraseña (opcional)"
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Button color="primary" onClick={handleUpdate}>
                    Guardar Cambios
                  </Button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Perfil;
